module.exports = __webpack_public_path__ + "img/2021_09_dande_kamigamo_fin_web.f46a3c52.jpg";